import { getToken } from '../helpers/Token';
import axios, { AxiosRequestConfig } from 'axios';
import watcherUrls from "../configs/watcher/watcherUrls";

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';

  if (!watcherUrls.isPublicUrl(config.baseURL, config.url)) {
    config.headers['Authorization'] = `Bearer ${getToken()}`;
  }

  return config;
}

const watcherApi = axios.create({ baseURL: watcherUrls.baseURL });
watcherApi.interceptors.request.use(onRequest);

export default watcherApi;
